export const environment = {
  production: true,
  hmr: false,
  issuer: 'https://engieapppreview.oktapreview.com/oauth2/default',
  clientId: '0oa8zz3bz1OSgqZx70x7',
  redirectUri: `https://meetelisa-dev.engie.com/authorization-code/callback`,
  scope: ['openid', 'email', 'profile', 'org', 'offline_access'],
  responseType: ['id_token', 'token', 'code'],
  callbackUrl: 'authorization-code/callback',
  callbackUrlWithToken: 'authorization-code/callback#code',
  baseApiUrl: `https://meetelisa-dev.engie.com/api/`,
  meetingDurationInMinutes: 30,
  schedulerStartHour: '07:00',
  schedulerEndHour: '18:00',
  workDayStartHour: '06:00',
  workDayEndHour: '19:00',
  maxKeywordLength: 49,
  redirectTimeInSeconds: 3,
  storageEncryptKey: 'a5abbb38-84cf-4386-bc97-a4d3b125696e',
  chatEnglish: 'https://engiegbstest.service-now.com/$chat_support.do?queueID=6394e070dbfacc10db2f300af4961952',
  chatDutch: 'https://engiegbstest.service-now.com/$chat_support.do?queueID=eaed2e82db1f9c50c2e463cad39619b1',
  chatGerman: 'https://engiegbstest.service-now.com/$chat_support.do?queueID=c0b59d75db5f5c10c2e463cad39619e5',
  chatFrench: 'https://engiegbstest.service-now.com/$chat_support.do?queueID=9649a00edbf544186695ccd405961902',
  chatItalian: 'https://engiegbstest.service-now.com/$chat_support.do?queueID=a026917ddb5f5c10c2e463cad39619bf',
  chatSpanish: 'https://engiegbstest.service-now.com/$chat_support.do?queueID=183615bddb5f5c10c2e463cad39619df',
  gdprUrl: 'https://cdn-digital-flexgen.engie.com/noprod/shared/gdpr.html'
};
